import { applicationConfig } from "@/constants/application-config.js";

function getLocalServiceOverrides() {
    try {
        return JSON.parse(process.env.__VUE_APP_LOCAL_SERVICE_OVERRIDES__ || "{}");
    } catch {
        return {};
    }
}

export function getApiBaseUrl(endpoint) {
    const normalizedEndpoint = endpoint.toLowerCase();

    if (applicationConfig.CURRENT_ENVIRONMENT !== "Localhost") {
        return applicationConfig.CONSUMER_CF_DISTRO;
    }

    const localServiceOverrides = getLocalServiceOverrides();

    const matchingPrefix = Object.keys(localServiceOverrides)
        .sort((a, b) => b.length - a.length)
        .find((pathPrefix) => normalizedEndpoint.startsWith(pathPrefix.toLowerCase()));

    const overrideBaseUrl = matchingPrefix ? localServiceOverrides[matchingPrefix] : "";

    if (overrideBaseUrl) {
        return overrideBaseUrl.replace(/\/$/, "");
    }

    return applicationConfig.CONSUMER_CF_DISTRO;
}
